<template>
<transition name="alert-fade">
<div class="np-alert np-alert-toast" v-if="showAlert" 
	:style="opts.style"
	:class="`np-alert-toast_${opts.type||'success'}`"
>
    
    <svg v-if="opts.type === 'success'" class="mg-r-sm"  viewBox="0 0 1024 1024"    width="16" height="16"><path d="M512 4.63280312c280.20621806 0 507.36719688 227.16097766 507.36719688 507.36719688S792.20621806 1019.36719688 512 1019.36719688 4.63280312 792.20621806 4.63280312 512 231.79378194 4.63280312 512 4.63280312z m217.15315969 353.59688379a38.05253973 38.05253973 0 0 0-53.81897457 0.03805256L448.88352115 585.06087631l-100.29381134-99.87523224a38.05253973 38.05253973 0 0 0-53.70481697 53.9204488l127.22232375 126.70227276a38.05253973 38.05253973 0 0 0 53.7809232-0.0761051l253.30307245-253.68359786a38.05253973 38.05253973 0 0 0-0.03805255-53.81897576z" p-id="2759" fill="#059A58"></path></svg>  
    <svg v-else-if="opts.type === 'error'" viewBox="0 0 1024 1024" class="mg-r-sm"  width="16" height="16"><path d="M980.72594913 314.55345444c-25.57047397-60.36756184-62.03311464-114.5341809-108.63368588-161.13350548s-100.76594363-83.0632119-161.13350545-108.6336859c-62.48690296-26.47680398-128.90830036-39.79125288-197.29445168-39.79125288s-134.80754874 13.46529614-197.2944517 39.79125288c-60.36756184 25.57047397-114.5341809 62.03311464-161.13350546 108.6336859-46.59932458 46.59932458-83.0632119 100.76594363-108.63368588 161.13350548-26.47680398 62.48690296-39.79125288 128.90830036-39.79125288 197.29445167s13.46529614 134.80754874 39.79125288 197.29445168c25.57047397 60.36756184 62.03311464 114.5341809 108.63368588 161.13350546 46.59932458 46.59932458 100.76594363 83.0632119 161.13350546 108.6336859 62.48690296 26.47680398 128.90830036 39.79125288 197.2944517 39.79125286s134.80754874-13.46529614 197.29445168-39.79125286c60.36756184-25.57047397 114.5341809-62.03311464 161.13350545-108.6336859 46.59932458-46.59932458 83.0632119-100.76594363 108.63368588-161.13350546 26.47680398-62.48690296 39.79125288-128.90830036 39.79125289-197.29445168s-13.31569559-134.80754874-39.79125289-197.29445167zM725.63457172 678.42936494c14.0699317 14.0699317 14.0699317 37.21937011 0 51.29054848s-37.21937011 14.0699317-51.29054849 0l-165.21884714-165.06675326-165.06675325 165.21884712c-14.0699317 14.0699317-37.21937011 14.0699317-51.29054845 0s-14.0699317-37.21937011 0-51.29054848l165.06675323-165.06675323-165.21884715-165.21884715c-14.0699317-14.0699317-14.0699317-37.21937011 0-51.29054847 14.0699317-14.0699317 37.21937011-14.0699317 51.29054849 0l165.06675326 165.06675326 165.06675325-165.06675326c14.0699317-14.0699317 37.21937011-14.0699317 51.29054849 0s14.0699317 37.21937011 0 51.29054847l-164.76505883 165.06675327 165.06675324 165.06675325z" fill="#cc0000" p-id="3090"></path></svg>        
		<i v-else-if="opts.type === 'warning'" class="icon mg-r-sm" style="color:#e6a23c;">
			&#xe60f;</i>
    <span v-else  class="mg-r-sm" v-html="opts.icon"></span>    
	<div class="np-alert-toast_content" :style="opts.contentStyle" 
		v-html = "msg"
	></div>
</div>
</transition>
</template>

<script>
export default {
	props:[
		"msg",
		"show",
		"duration",
		"onClose",
		"options"
	],
	data: function(){
		return {
			showClass:false,
			showAlert: false,
			opts:null
		}
	},
	computed: {
		
	},
	created: function(){
		this.opts = this.options || {};
	},
	mounted: function(){
		var _this = this;
			_this.showAlert = _this.show;
			_this.autoClose();		
	},
	methods:{
		autoClose: function(){
			var _this = this, duration = _this.duration || 3000;
			//自动关闭
			if(duration){
				setTimeout(function(){
					_this.close();
				},duration);
			}			
		},
		close:function(){
			this.showAlert = false;
			if(typeof this.opts.onClose === "function"){
				this.opts.onClose();
			}			
		}
	}
}
</script>
<style lang="scss">
$alert-rs: $border-radius-xs;
$alert-padding: $space-padding-md;
$alert-color:#666;
.np-alert {
	z-index: 3988;
	&-toast {
		position: fixed;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        padding: 7px 15px;
        border-radius: 6px;
        color: $alert-color;
        z-index: 9999;
        display: flex;
        align-items: center;
        max-width: 80vw;
        background-color: #FEF3CF;
        animation: alert-fade-slide-down 0.15s ease-in-out;
        box-shadow: 0 0  8px rgba(0 ,0,0,0.1);        
	}	
}
.alert-fade-enter-active,
.alert-fade-leave-active {
  transition: opacity 0.15s;
}

.alert-fade-enter,
.alert-fade-leave-to {
  opacity: 0;
}
.np-toast-a,.np-toast-d,.np-toast-f{fill:none;}.np-toast-a,.np-toast-d{stroke:#fff;}.np-toast-b{fill:#c00;stroke:#c00;}.np-toast-c{clip-path:url(#np-toast-a);}.np-toast-d{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px;}.np-toast-e{stroke:none;}
@keyframes alert-fade-slide-down {
  0% {
    top: 0;
  }
  100% {
    top: 10%;
  }
}
</style>
